<mde-popover
  #detailPopover="mdePopover"
  [mdePopoverOverlapTrigger]="false"
  mdePopoverArrowColor="#FFFFFF"
  [mdePopoverCloseOnClick]="false"
  mdePopoverOffsetX="-19"
  mdePopoverOffsetY="-1"
>
  <vex-general-tooltip [label]="label" [value]="value"></vex-general-tooltip>
</mde-popover>
<div class="card relative hover:shadow-16 trans-shadow">
  <div class="rounded p-2 myStyle">
    <div class="border-b mb-2">
      <div fxLayout="row" class="mb-2" fxLayoutAlign="space-between center">
        <div fxLayout="row">
          <img
            class="w-20 h-20 avatar"
            [src]="getImageByCloudKey()"
            alt="User Picture"
            loading="lazy"
            decoding="async"
            onError="this.src='assets/default/Custom/no-image-available.svg'"
          />
          <div fxLayout="column" class="pl-2">
            <div fxLayout="row" (mouseenter)="showTooltip(inventory.Name, 'Name')">
              <p
                class="font-medium text-over-flow cursor-pointer hover:text-primary trans-ease-out"
                (click)="openDetails()"
                [mdePopoverTriggerFor]="detailPopover"
                #target="mdePopoverTrigger"
                mdePopoverTriggerOn="hover"
              >
                {{ inventory?.Name || 'N/A' }}
                <button color="primary" type="button">
                  <ic-icon
                    [icon]="icExternalLink"
                    class="mx-1"
                    inline="true"
                    size="15px"
                    *ngIf="inventory?.Name"
                  ></ic-icon>
                </button>
              </p>
            </div>
            <div
              class="text-secondary font-medium text-xs"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              <p class="imported-color">{{ cloudName }}</p>
              <p
                *ngIf="inventoryType"
                class="w-1 h-1 bg-gray rounded-full mr-2 ml-2"
              ></p>
              <p>{{ inventoryType }}</p>
            </div>
            <div fxLayout="row">
              <div class="label bg-purple-light text-purple" fxFlex="none">
                <b>v {{ inventory.Version }}</b>
              </div>
              <div class="label ml-1" style="display: inherit" fxFlex="none" [ngClass]="state?.LblClass">
                <span *ngIf="inventory.State == 14">
                  <mat-icon class="mt-1" [icIcon]="icLock" style="font-size: 20px"></mat-icon>
                </span>
                {{ state?.Value }}
              </div>
              <div
                class="ml-1 label bg-red-light text-red"
                fxFlex="none"
                *ngIf="!isDataCenter()"
              >
                <ng-container *ngIf="inventory.LastMonthsCost != null; else nacost">
                  <b>${{ inventory.LastMonthsCost?.toFixed(2) }}</b>
                </ng-container>
                <ng-template #nacost> $ N/A </ng-template>
              </div>
            </div>
          </div>
        </div>
        <ng-content select="[rightHeaderContent]"></ng-content>
      </div>
    </div>

    <div fxLayout="row">
      <div class="image-div">
        <ng-container *ngIf="!bindDefaultImage; else templateIcon">
          <img
            [src]="inventory.Blueprint?.ImagePath"
            loading="lazy"
            decoding="async"
            (error)="bindDefaultImage = true"
            lightbox
          />
        </ng-container>
        <ng-template #templateIcon>
          <ng-container *ngIf="inventory.InventoryType == InventoryType.Iac; else cloudIcon">
            <img [src]="getDefaultImage(inventory.Clouds[0])" loading="lazy" decoding="async" />
          </ng-container>
          <ng-template #cloudIcon>
            <img
              [src]="getDefaultImage(inventory.Blueprint.CloudName)" 
              loading="lazy"
              decoding="async"
            />
          </ng-template>
        </ng-template>
      </div>
      <div fxLayout="column" class="w-full ml-4">
        <div class="mb-4" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="16px">
          <div fxFlex>
            <ng-container *ngIf="!inventory.DeviceId; else deviceName">
              <p class="primary leading-normal">Blueprint :</p>
              <ng-container *ngIf="!inventory.Imported; else blueprintText">
                <p
                  (mouseenter)="showTooltip(inventory.Blueprint.Name, 'Blueprint')"
                  (click)="goToBlueprint()"
                  [mdePopoverTriggerFor]="detailPopover"
                  #target="mdePopoverTrigger"
                  mdePopoverTriggerOn="hover"
                >
                  <span class="font-medium header-text text-primary avi-link">{{ inventory.Blueprint.Name }}</span>
                  <span class="small-label bg-purple-light text-purple ml-1"> <b>v {{ inventory.Blueprint.Version }}</b></span>
                  <button color="primary" type="button">
                    <ic-icon
                      [icon]="icExternalLink"
                      class="mx-1"
                      inline="true"
                      size="15px"
                    ></ic-icon>
                  </button>
                </p>
              </ng-container>
              <ng-template #blueprintText>
                <p
                  (mouseenter)="showTooltip(inventory.Blueprint.Name, 'Blueprint')"
                  class="font-medium header-text"
                  [mdePopoverTriggerFor]="detailPopover"
                  #target="mdePopoverTrigger"
                  mdePopoverTriggerOn="hover"
                >
                  {{ inventory.Blueprint.Name }}
                </p>
              </ng-template>
            </ng-container>
            <ng-template #deviceName>
              <p class="primary leading-normal">Device Name :</p>
              <p
                (mouseenter)="showTooltip(inventory.DeviceName, 'Device')"
                class="font-medium header-text"
                [mdePopoverTriggerFor]="detailPopover"
                #target="mdePopoverTrigger"
                mdePopoverTriggerOn="hover"
              >
                {{ inventory.DeviceName }}
              </p>
            </ng-template>
          </div>
          <ng-container *ngIf="isDriftedAndImportedShow">
            <div fxFlex>
              <p class="primary leading-normal">Is Drifted from BP? :</p>
              <p
                class="font-medium header-text"
              >
                {{ version ? 'Yes' : 'No' }}
              </p>
            </div>
          </ng-container>
          <div fxFlex>
            <p class="primary leading-normal">Created :</p>
            <p
              class="font-medium header-text"
            >
              {{ inventory?.CreatedBy }}
              {{ inventory?.CreatedDate | dateFormat }}
            </p>
          </div>
        </div>
        
        <div class="mb-4" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="16px">
          <div fxFlex *ngIf="showIpam">
            <p class="primary leading-normal">IPAM :</p>
            <ng-container *ngIf="inventory?.IpPoolName && inventory?.IpPoolName !== 'N/A'; else noLink">
              <a target="_blank" [href]="'/ip-pools/detail-ip-pool/' + inventory?.IpPoolId">
                <p
                  class="font-medium header-text text-primary avi-link"
                  [mdePopoverTriggerFor]="detailPopover"
                  #target="mdePopoverTrigger"
                  mdePopoverTriggerOn="hover"
                >
                  {{ inventory.IpPoolName }}
                  <button color="primary" type="button">
                    <ic-icon
                      [icon]="icExternalLink"
                      class="mx-1"
                      inline="true"
                      size="15px"
                    ></ic-icon>
                  </button>
                </p>
              </a>
            </ng-container>
            <ng-template #noLink>
              <p
                class="font-medium header-text "
              >
                N/A
              </p>
            </ng-template>
          </div>
          <ng-container *ngIf="isDriftedAndImportedShow">
            <div fxFlex>
              <p class="primary leading-normal">Is Imported? :</p>
              <p
                class="font-medium header-text"
              >
                {{ inventory.Imported ? 'Yes' : 'No' }}
              </p>
            </div>
          </ng-container>
          <div fxFlex>
            <p class="primary leading-normal">Changed :</p>
            <p
              class="font-medium header-text"
            >
              {{ inventory?.UpdatedBy ||  inventory?.CreatedBy}}
              {{ inventory?.UpdatedDate || inventory?.CreatedDate | dateFormat }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-content select="[bottomContent]"></ng-content>
  </div>
</div>
